module.exports = __webpack_public_path__ + "img/dries-m.7fa416b5.jpeg";